import React, { useState } from 'react';
import '../styles/ChatBot.css';

const Chatbot = () => {
const [messages, setMessages] = useState([]);
const [input, setInput] = useState('');

const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: 'user', text: input };
    setMessages([...messages, userMessage]);

    try {
    const res = await fetch('http://localhost:8000/chatbot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: input }),
    });

    const data = await res.json();
    const botMessage = { sender: 'bot', text: data.reply };
    setMessages(prev => [...prev, botMessage]);
    } catch (error) {
    setMessages(prev => [
        ...prev,
        { sender: 'bot', text: 'Error contacting AI server.' },
    ]);
    }

    setInput('');
};

return (
    <div className="chatbot-container">
    <h2>AI Chatbot</h2>
    <div className="chatbox">
        {messages.map((msg, i) => (
        <div key={i} className={`message ${msg.sender}`}>
            {msg.text}
        </div>
        ))}
    </div>
    <div className="input-box">
        <input
        value={input}
        onChange={e => setInput(e.target.value)}
        placeholder="Type your message..."
        onKeyDown={e => e.key === 'Enter' && sendMessage()}
        />
        <button onClick={sendMessage}>Send</button>
    </div>
    </div>
);
};

export default Chatbot;
